import { RadioCardV3 } from '@toolbox/components';
import { useStepContext } from '@widget/core';

import type { RadioCardProps as BaseRadioCardProps } from '@toolbox/components';

export type RadioCardProps = BaseRadioCardProps & {
  nextStep?: string;
  redirectUrl?: string | null;
  submit?: boolean;
};

export const RadioCard = ({
  nextStep,
  redirectUrl,
  iconHover,
  submit: submitProp,
  ...props
}: RadioCardProps): JSX.Element => {
  const { setNextStep, submit } = useStepContext();
  const handleChange = (value: string | number): void => {
    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
      return;
    }

    if (nextStep) {
      setNextStep(nextStep);
    }

    props.onChange?.(value);

    // TODO - The step gets submit without data, so we have to do this, becuase widgetx itself has a lot of `setTimeout()` implemented. When we start getting rid of WidgetX we need to make sure that we don't have same bug.
    if (submitProp) {
      queueMicrotask(submit); // wait onChange to propagate before submitting Step
    }
  };

  return <RadioCardV3 {...props} onChange={handleChange} />;
};
